<template>
    <div v-if="property">
        <h4 class="title is-5">
            Photos
        </h4>

        <Notification v-if="! photos && ! hasPhotos">
            Loading photos...
        </Notification>

        <Notification v-if="photos && ! hasPhotos">
            No photos available
        </Notification>

        <b-carousel-list
            v-if="hasPhotos"
            :data="photosCarousel"
            arrow
            has-drag
            :autoplay="false"
            :repeat="false"
        />

        <hr />

        <h4 class="title is-5">
            EPCs
        </h4>

        <Notification v-if="! epcs && ! hasEpcs">
            Loading EPCs...
        </Notification>

        <Notification v-if="epcs && ! hasEpcs">
            No EPCs available
        </Notification>

        <b-carousel-list
            v-if="hasEpcs"
            :data="epcsCarousel"
            arrow
            has-drag
            :autoplay="false"
            :repeat="false"
        />

        <hr />

        <h4 class="title is-5">
            Floor Plans
        </h4>

        <Notification v-if="! floorPlans && ! hasFloorPlans">
            Loading floor plans...
        </Notification>

        <Notification v-if="floorPlans && ! hasFloorPlans">
            No floor plans available
        </Notification>

        <b-carousel-list
            v-if="hasFloorPlans"
            :data="floorPlansCarousel"
            arrow
            has-drag
            :autoplay="false"
            :repeat="false"
        />
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import Notification from './Notification';

export default {
    components: {
        Notification,
    },

    computed: {
        ...mapState('salesProperty', [
            'property',
            'photos',
            'epcs',
            'floorPlans',
        ]),
        ...mapGetters('salesProperty', [
            'hasPhotos',
            'photosCarousel',
            'hasEpcs',
            'epcsCarousel',
            'hasFloorPlans',
            'floorPlansCarousel',
        ]),
    },

    mounted() {
        this.$store.dispatch('salesProperty/getPhotos', this.$route.params.id);
        this.$store.dispatch('salesProperty/getEpcs', this.$route.params.id);
        this.$store.dispatch('salesProperty/getFloorPlans', this.$route.params.id);
    },
};
</script>
